import { render, staticRenderFns } from "./languageSelector.vue?vue&type=template&id=70c4736a&scoped=true&lang=html&"
import script from "./languageSelector.vue?vue&type=script&lang=js&"
export * from "./languageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c4736a",
  null
  
)

export default component.exports